import { SessionStoreModuleType } from "UidispatcherApiModule";
const { SessionStoreModule }: { SessionStoreModule: SessionStoreModuleType } =
    // @ts-expect-error
    await import("uidispatcher_api/UidispatcherApiModule");
export const SessionStore = SessionStoreModule.SessionStore;
export const LogoutManualAction = SessionStoreModule.LogoutManualAction;
